"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CustomerSourceModel () {
        return CustomerSourceModel;
    },
    get StripeCustomerModel () {
        return StripeCustomerModel;
    }
});
const _zod = require("zod");
/**
 * Custom Zod schema definitions for Stripe customer data, created to avoid performance
 * issues caused by importing types directly from the Stripe package. These simplified
 * models prevent TypeScript server slowdowns while still providing type safety for
 * stripe_customer_info and default_source fields.
 */ const SourceBase = _zod.z.object({
    id: _zod.z.string(),
    object: _zod.z.string(),
    metadata: _zod.z.record(_zod.z.string(), _zod.z.string()).nullable().optional()
}).passthrough();
const BankAccountModel = SourceBase.extend({
    object: _zod.z.literal("bank_account")
}).passthrough();
const CardModel = SourceBase.extend({
    object: _zod.z.literal("card")
}).passthrough();
const GenericSourceModel = SourceBase.extend({
    object: _zod.z.literal("source")
}).passthrough();
const AccountModel = SourceBase.extend({
    object: _zod.z.literal("account")
}).passthrough();
const CustomerSourceModel = _zod.z.discriminatedUnion("object", [
    AccountModel,
    BankAccountModel,
    CardModel,
    GenericSourceModel
]);
const StripeCustomerModel = _zod.z.object({
    id: _zod.z.string(),
    default_source: _zod.z.string().or(CustomerSourceModel).nullable().optional(),
    invoice_settings: _zod.z.object({
        default_payment_method: _zod.z.string().nullable()
    }).optional()
});
